'use client';

import React from 'react';
import { Autoplay, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

import {
  Box,
  Container,
  Flex,
  Image,
  Link,
  SectionHeading,
} from '@/components';
import { useTranslation } from '@/hooks';
import useBrands from '@/hooks/queries/useBrands';
import { routes } from '@/statics';

const Brands: React.FC = () => {
  const { t } = useTranslation('pages.home');

  const { data: brands } = useBrands();

  if (!brands?.length) {
    return null;
  }

  // Swiper rounds 2.5 visible slides up to 3 and needs one more for looping.
  const canLoop = brands.length >= 4;

  return (
    <Flex
      my={{ base: '70px', md: '50px' }}
      justifyContent="center"
      flexDir="column"
      display="flex"
      gap="30px"
    >
      <SectionHeading
        title={t('brands')}
        subtitle={t('chooseBrand')}
        textAlign="center"
        w="full"
      />
      <Container>
        <Flex
          display={{ base: 'none', md: 'flex' }}
          overflow="hidden"
          justify="space-around"
          align="center"
          px={10}
          gap={10}
          h="130px"
          bg={'complimentary.3'}
        >
          {brands?.map((brand) => (
            <Link
              key={brand.code}
              href={routes.brand.href(brand.code)}
              w="full"
              maxW="226px"
            >
              <Box
                display="block"
                width="100%"
                position="relative"
                height="auto"
                aspectRatio={210 / 122}
                sx={{
                  img: {
                    objectFit: 'contain',
                  },
                }}
              >
                <Image src={brand.image || ''} alt={brand.code} fill />
              </Box>
            </Link>
          ))}
        </Flex>
      </Container>
      <Box
        w="full"
        py={6}
        display={{ base: 'block', md: 'none' }}
        h="132px"
        bg={'complimentary.3'}
      >
        <Swiper
          key={canLoop ? 'loop' : 'static'}
          slidesPerView={2.5}
          loop={canLoop}
          centeredSlides
          dir="rtl"
          speed={1000}
          modules={[Autoplay, FreeMode]}
          autoplay
          onTouchEnd={(swiper) => swiper.autoplay.resume()}
          grabCursor={false}
        >
          {brands.map((brand, index) => (
            <SwiperSlide
              key={index}
              style={{ width: '40%', paddingInline: '10px' }}
            >
              <Link key={brand.code} href={routes.brand.href(brand.code)}>
                <Box
                  display="block"
                  width="100%"
                  position="relative"
                  height="auto"
                  aspectRatio={210 / 122}
                  sx={{
                    img: {
                      objectFit: 'contain',
                    },
                  }}
                >
                  <Image src={brand.image || ''} alt={brand.code} fill />
                </Box>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Flex>
  );
};
export default Brands;
